import inViewport from '../../../../javascripts/helpers/inViewport';

const teaserImage = element => inViewport(element, 0.7);

export default teaserImage;
